if (!customElements.get('adev-bg-audio')) {
    customElements.define('adev-bg-audio', class adevBackgroundAudio extends HTMLElement {
        constructor() {
            super();
        }

        init() {
            this.buttonEl = this.querySelector('[data-adev-bg-audio="btn"]');
            this.audioEl = this.querySelector('audio[data-adev-bg-audio="audio"]');
            
            this.buttonEl.addEventListener('click', () => this.toggleAudio());

            // if (!this.userPreferredAudioPaused()) {
            // }

            this.autoplayAudio();

            this.audioEl.addEventListener('play', () => this.onPlayOrPause());
            this.audioEl.addEventListener('pause', () => this.onPlayOrPause());
        }

        onPlayOrPause() {
            if (this.audioEl.paused) {
                this.buttonEl.classList.remove('is--playing');
                this.buttonEl.setAttribute('aria-pressed', 'false');
            } else {
                this.buttonEl.classList.add('is--playing');
                this.buttonEl.setAttribute('aria-pressed', 'true');
            }
        }

        autoplayAudio() {
            this.audioEl.play().then(() => {
                this.buttonEl.setAttribute('aria-pressed', 'true');
            }).catch((error) => {
                this.buttonEl.setAttribute('aria-pressed', 'false');
                
                this._userInteractionHandler = () => {
                    this.audioEl.play().then(() => {
                        this.buttonEl.setAttribute('aria-pressed', 'true');
                        
                        document.removeEventListener('touchend', this._userInteractionHandler);
                        document.removeEventListener('touchstart', this._userInteractionHandler);
                        document.removeEventListener('click', this._userInteractionHandler);
                        document.removeEventListener('scroll', this._userInteractionHandler);
                        document.removeEventListener('keydown', this._userInteractionHandler);
                        document.removeEventListener('mousemove', this._userInteractionHandler);
                    }).catch((err) => {
                        console.warn('Autoplay retry failed:', err);
                    });
                };

                document.addEventListener('touchend', this._userInteractionHandler, { once: true });
                document.addEventListener('touchstart', this._userInteractionHandler, { once: true });
                document.addEventListener('click', this._userInteractionHandler, { once: true });
                document.addEventListener('scroll', this._userInteractionHandler, { once: true });
                document.addEventListener('keydown', this._userInteractionHandler, { once: true });
                document.addEventListener('mousemove', this._userInteractionHandler, { once: true });
            });
        }

        toggleAudio() {
            if (this.audioEl.paused) {
                this.audioEl.play();
                this.buttonEl.setAttribute('aria-pressed', 'true');
            } else {
                this.audioEl.pause();
                this.buttonEl.setAttribute('aria-pressed', 'false');
            }

            this.rememberAudioState();
        }

        rememberAudioState() {
            const isPlaying = !this.audioEl.paused;
            const threedays = 3 * 24 * 60 * 60; // 3 days in seconds
            document.cookie = `adev_bg_audio_state=${isPlaying ? 'playing' : 'paused'}; path=/; max-age=${threedays}`;
        }

        userPreferredAudioPaused() {
            const match = document.cookie.match(/(^| )adev_bg_audio_state=(playing|paused)(;|$)/);
            return match ? match[2] === 'paused' : null;
        }

        destroy() {
            this.buttonEl.removeEventListener('click', () => this.toggleAudio());
            
            if (this._userInteractionHandler) {
                document.removeEventListener('touchend', this._userInteractionHandler);
                document.removeEventListener('touchstart', this._userInteractionHandler);
                document.removeEventListener('click', this._userInteractionHandler);
                document.removeEventListener('scroll', this._userInteractionHandler);
                document.removeEventListener('keydown', this._userInteractionHandler);
                document.removeEventListener('mousemove', this._userInteractionHandler);
                this._userInteractionHandler = null;
            }
        }

        connectedCallback() {
            this.init();
        }

        disconnectedCallback() {
            this.destroy();
        }

    });
}